type Props = { size?: number; color?: string };

export function IconTiktok({ size = 16, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="1.9"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M15 4v9.2a3.6 3.6 0 1 1-3-3.55" />
			<path d="M15 4c.6 2.2 2.2 3.6 4.3 3.9" />
		</svg>
	);
}
